@if (data.title) {
  <h1 mat-dialog-title>{{data.title}}</h1>
}
<mat-dialog-content>
  @if (loading) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  <div [innerHTML]="safeContent"></div>
</mat-dialog-content>
<mat-dialog-actions align='end'>

  <button mat-flat-button (click)='onYesClick()' color='accent' >{{data.positiveText?data.positiveText:'chiudi' | translate}}</button>
</mat-dialog-actions>
